import { useMelioIntl } from '@melio/ar-domain';
import { FundingSource } from '@melio/platform-api';
import { forwardRef } from '@melio/platform-utils';

import { FundingSourceIcon, LineItem, Section } from '../../../components';
import { getFundingSourceDisplayName, getFundingSourceLabel } from '../../../utils';

export type PaymentSourceSectionProps = {
  fundingSource: FundingSource;
  scheduleDate: Date;
  onEditScheduleDate?: VoidFunction;
  onEditFundingSource?: VoidFunction;
  paddingX?: string;
  isDisabled?: boolean;
};

export const PaymentSourceSection = forwardRef<PaymentSourceSectionProps>(
  ({ fundingSource, scheduleDate, onEditScheduleDate, onEditFundingSource, isDisabled, children, ...props }, ref) => {
    const { formatDate, formatMessage } = useMelioIntl();
    return (
      <Section
        data-component={PaymentSourceSection.displayName}
        title={formatMessage('ar.guestPayment.activities.paymentReview.subTitle.payFrom.label')}
        {...props}
        ref={ref}
      >
        <LineItem
          data-testid="payment-source"
          label={getFundingSourceLabel(fundingSource)}
          icon={<FundingSourceIcon fundingSource={fundingSource} />}
          onEdit={onEditFundingSource}
          isDisabled={isDisabled}
        >
          {getFundingSourceDisplayName(fundingSource)}
        </LineItem>
        <LineItem
          data-testid="payment-date"
          label={formatMessage('ar.guestPayment.activities.paymentReview.sections.debitDate.title.label')}
          icon="calendar"
          onEdit={onEditScheduleDate}
          isDisabled={isDisabled}
        >
          {formatDate(scheduleDate)}
        </LineItem>
        {children}
      </Section>
    );
  }
);
PaymentSourceSection.displayName = 'PaymentSourceSection';
